import MAE from './indicators/mae';
import PRICE from './indicators/price';

/**
 * Enums associated with various indicators
 * @readonly
 * @enum {object}
 */
export default Object.freeze({
	/** Enums associated with MAE indicator */
	MAE,
	/** Enums associated with Price indicator */
	PRICE
});
